import React from 'react';
import { IdleTimerProvider } from 'react-idle-timer';
import { useNavigate } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

const IdleTimer = ({ children }: Props) => {
  const navigate = useNavigate();
  const timeout = 89 * 60000;
  const onIdle = () => {
    localStorage.removeItem('backlink.user');
    sessionStorage.removeItem('backlink.user');
    navigate('/login');
  };

  return (
    <IdleTimerProvider onIdle={onIdle} timeout={timeout}>
      {children}
    </IdleTimerProvider>
  );
};

export default IdleTimer;
